(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.espVariantSyncReady === 'true') return;
    root.dataset.espVariantSyncReady = 'true';

    var jsonNode = root.querySelector('[data-esp-variants]');
    if (!jsonNode) return;

    var variants;
    try { variants = JSON.parse(jsonNode.textContent || '[]'); }
    catch (e) { return; }
    if (!variants.length) return;

    var track = root.querySelector('[data-esp-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.esp-slide[data-media-id]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-esp-thumb]'));
    var fields = Array.prototype.slice.call(root.querySelectorAll('[data-esp-opt]'));
    var idInput = root.querySelector('[data-esp-id]');
    var priceEl = root.querySelector('[data-esp-price]');
    var stockEl = root.querySelector('[data-esp-stock]');
    var stockText = stockEl ? stockEl.querySelector('[data-esp-stock-text]') : null;
    var atc = root.querySelector('[data-esp-atc]');
    var buyNow = root.querySelector('[data-esp-now]');
    var msg = root.querySelector('[data-esp-msg]');
    var quoteVariant = root.querySelector('[data-esp-quote-variant]');
    var count = root.querySelector('[data-esp-count]');
    var form = root.querySelector('#esp-form') || root.querySelector('form.esp-form');
    var current = null;
    var activeIndex = 0;

    function selectedOptions() {
      return fields.map(function (field) {
        var checked = field.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options && variant.options.length === options.length &&
          variant.options.every(function (value, index) {
            return String(value) === String(options[index]);
          });
      }) || null;
    }

    function setSlide(index, fromImageClick) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(index, slides.length - 1));
      activeIndex = index;
      if (track) {
        var slide = slides[index];
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function (thumb) {
        var isActive = Number(thumb.getAttribute('data-esp-thumb')) === index;
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;

      if (fromImageClick) {
        var mediaId = String(slides[index].getAttribute('data-media-id') || '');
        var linked = variants.find(function (variant) {
          return String(variant.media || '') === mediaId && variant.available;
        }) || variants.find(function (variant) {
          return String(variant.media || '') === mediaId;
        });
        if (linked && linked.options) {
          linked.options.forEach(function (value, optionIndex) {
            var field = fields[optionIndex];
            if (!field) return;
            var radio = Array.prototype.find.call(
              field.querySelectorAll('input[type="radio"]'),
              function (input) { return input.value === String(value); }
            );
            if (radio) radio.checked = true;
            var label = field.querySelector('[data-esp-opt-val]');
            if (label) label.textContent = value;
          });
          updateVariant();
        }
      }
    }

    function updateVariant() {
      var options = selectedOptions();
      var match = findVariant(options);
      current = match;

      fields.forEach(function (field, index) {
        var label = field.querySelector('[data-esp-opt-val]');
        if (label && options[index] !== undefined) label.textContent = options[index];
      });

      if (!match) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        if (buyNow) buyNow.hidden = true;
        if (stockText) stockText.textContent = 'Unavailable';
        if (stockEl) stockEl.classList.add('is-out');
        if (msg) msg.textContent = 'This combination is unavailable.';
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl && match.price) priceEl.textContent = match.price;
      if (stockText) stockText.textContent = match.available ? 'In stock' : 'Sold out';
      if (stockEl) stockEl.classList.toggle('is-out', !match.available);
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? 'Add to basket' : 'Sold out';
      }
      if (buyNow) buyNow.hidden = !match.available;
      if (quoteVariant) quoteVariant.value = match.options.join(' / ');
      if (msg) msg.textContent = '';

      if (match.media) {
        var mediaIndex = slides.findIndex(function (slide) {
          return String(slide.getAttribute('data-media-id')) === String(match.media);
        });
        if (mediaIndex >= 0 && mediaIndex !== activeIndex) setSlide(mediaIndex, false);
      }
    }

    fields.forEach(function (field) {
      field.addEventListener('change', updateVariant);
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setSlide(Number(thumb.getAttribute('data-esp-thumb')), true);
      });
    });

    if (track) {
      track.addEventListener('click', function (event) {
        var slide = event.target.closest('.esp-slide');
        if (!slide) return;
        var index = slides.indexOf(slide);
        if (index >= 0) setSlide(index, true);
      });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); setSlide(activeIndex + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); setSlide(activeIndex - 1, true); }
      });
      var scrollFrame = null;
      track.addEventListener('scroll', function () {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(function () {
          if (!slides.length) return;
          var nearest = 0, distance = Infinity;
          slides.forEach(function (slide, index) {
            var d = Math.abs(slide.offsetLeft - track.scrollLeft);
            if (d < distance) { distance = d; nearest = index; }
          });
          activeIndex = nearest;
          thumbs.forEach(function (thumb) {
            thumb.setAttribute('aria-current',
              Number(thumb.getAttribute('data-esp-thumb')) === nearest ? 'true' : 'false');
          });
          if (count) count.textContent = (nearest + 1) + ' / ' + slides.length;
        });
      }, { passive: true });
    }

    var prev = root.querySelector('[data-esp-prev]');
    var next = root.querySelector('[data-esp-next]');
    if (prev) prev.addEventListener('click', function () { setSlide(activeIndex - 1, true); });
    if (next) next.addEventListener('click', function () { setSlide(activeIndex + 1, true); });

    root.querySelectorAll('[data-esp-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('[data-esp-qty-input]');
        if (!input) return;
        var step = Number(button.getAttribute('data-esp-qty')) || 0;
        input.value = Math.max(1, (Number(input.value) || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        if (!current || !current.available) return;
        var oldAction = form.getAttribute('action');
        form.setAttribute('action', '/cart');
        var checkout = document.createElement('input');
        checkout.type = 'hidden';
        checkout.name = 'return_to';
        checkout.value = '/checkout';
        form.appendChild(checkout);
        form.requestSubmit();
        setTimeout(function () {
          checkout.remove();
          if (oldAction) form.setAttribute('action', oldAction);
          else form.removeAttribute('action');
        }, 1000);
      });
    }

    // Product information tabs
    var tabsRoot = root.querySelector('[data-esp-tabs]');
    if (tabsRoot) {
      var tabs = Array.prototype.slice.call(tabsRoot.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (item) {
            var active = item === tab;
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            item.tabIndex = active ? 0 : -1;
            var panel = tabsRoot.querySelector('#' + item.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
        });
      });
    }

    // Quote dialog
    var dialog = root.querySelector('[data-esp-quote]');
    var openQuote = root.querySelector('[data-esp-quote-open]');
    var closeQuote = root.querySelector('[data-esp-quote-close]');
    if (dialog && openQuote) openQuote.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
    if (dialog && closeQuote) closeQuote.addEventListener('click', function () { dialog.close(); });

    // Initial state is based on Shopify's selected/first available variant.
    updateVariant();
    if (slides.length) {
      var initialMedia = current && current.media ? String(current.media) : '';
      var initialIndex = slides.findIndex(function (slide) {
        return String(slide.getAttribute('data-media-id')) === initialMedia;
      });
      setSlide(initialIndex >= 0 ? initialIndex : 0, false);
    }
  }

  function start() {
    document.querySelectorAll('[data-esp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
